import { Model, MapTo } from 'src/app/decorators/mapto';
export class DelivererModel extends Model {
    @MapTo()
    id: string;
    @MapTo()
    name: string;
    @MapTo()
    email: string;
    @MapTo()
    contact_number: string;
    @MapTo()
    cnic: string;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }

    get Name(): string {
        return this.name || 'N/A';
    }

    get Id(): string {
        return this.id || null;
    }
}
